export default {
    theme:   { light: 'Tema Claro', dark: 'Tema Escuro' },
    login:{
      textCredenciais:'Digite suas credenciais',
      acessLogin:'Usuario',
      acessPassword:'Senha',
      lembrarSenha:'Lembrar usuario e senha',
      forgotPass:'Esqueci minha senha',
      Enter:'Entrar',
      escolhaApelido:'Escolha seu apelido',
      descApelido:'Para continuar, defina um apelido de exibição.'
    },
  registro: {
    titleRegister: 'Registrar',
    labelUsuario: 'Usuário',
    ruleUsuarioRequired: 'Usuário é obrigatório',
    labelApelido: 'Apelido',
    ruleApelidoRequired: 'Apelido é obrigatório',
    labelEmail: 'E-mail',
    ruleEmailRequired: 'E-mail é obrigatório',
    ruleEmailInvalid: 'E-mail inválido',
    labelSenha: 'Senha',
    ruleSenhaRequired: 'Senha é obrigatória',
    ruleSenhaMin: 'Mínimo 8 caracteres',
    ruleSenhaLetter: 'Use ao menos uma letra',
    ruleSenhaNumber: 'Use ao menos um número',
    ruleSenhaSymbol: 'Use ao menos um símbolo',
    strengthFraca: 'Fraca',
    strengthMedia: 'Média',
    strengthForte: 'Forte',
    labelRepeatPassword: 'Repetir Senha',
    ruleConfirmationRequired: 'Confirmação é obrigatória',
    rulePasswordsMatch: 'Senhas não conferem',
    btnRegister: 'Registrar',
    alertSuccess: 'Conta pendente criada! Verifique seu código de confirmação.'
  },
   download: {
    title: 'Faça o download do nosso client agora',
    btnDownload: 'Baixar'
  },
  characters: {
    title: 'Meus personagens',
    youHave: 'Você tem {count} personagem(s).',
    noCharacters: 'Você não possui personagens.',
    classLabel: 'Classe:',
    levelLabel: 'Nível:',
    goldLabel: 'Gold:',
    silverLabel: 'Prata:',
    bronzeLabel: 'Bronze:',
    createdLabel: 'Criação:',
    rebirthsLabel: 'Reencarnações:',
    bannedLabel: 'Banido:',
    yes: 'Sim',
    no: 'Não'
  },
    menu: {
      home: 'Principal',
      login: 'Entrar',
      register: 'Registrar',
      download: 'Download',
      discord: 'Discord',
      info: 'Meus Personagens',
      changePassword: 'Alterar Informações',
      inbox: 'Caixa de Mensagens (em desenvolvimento)',
      market: 'Shopping Zephyr',
      coinsBr: 'Zephyr Coins Brasil',
      coinsInt: 'Zephyr Coins Internacional',
      wikia: 'Zephyr Wikia',
      ranked: 'Pontuação Rankeada',
      alquimia: 'Criar Alquimia',
      atts: 'Notas de atualização',
      roulette: 'Roleta da Sorte',
      daily: 'Coleta Diária',
      casino: 'Cassino Zephyr (em desenvolvimento)',
      escala: 'Escala Zephyr',
      logout: 'Sair',
      loggedAs:'Logado como',
      servicos: 'Serviços'
    },
    snackbar: { newMessages: 'Você recebeu {count} nova(s) mensagem(ns)!' },
    footer:   { copy: '{site} - Todos os direitos reservados' },
    hero: {
      title:    'Grand Fantasia Zephyr',
      subtitle: 'o melhor servidor de Grand Fantasia privado'
    },
    chat: { greeting: 'Olá! Estamos ansiosos em ter você, acesse o nosso discord!' },
  
    ranks: {
      title:        'DESTAQUES',
      currentMonth: 'Mês de: {month}',
      deaths:       'Top Mortes',
      crystalDamage:'Top Dano Cristal',
      heal:         'Top Cura',
      playerDamage: 'Top Dano em Jogadores',
      wins:         'Top Vitórias',
      noData:       '— sem dados'
    },
  
    changeCreds: {
      greeting1: 'Parece que não está muito seguro rs...',
      greeting2: 'Pode alterar suas credenciais',
  
      newEmail: {
        label: 'Novo E-mail (!)',
        hint:  'Você não é obrigado a trocar o e-mail; faça se quiser.'
      },
      currentPassword: { label: 'Senha Atual' },
      newPassword:     { label: 'Nova Senha' },
      confirmPassword: { label: 'Repetir Nova Senha' },
  
      updateButton: 'Atualizar',
  
      emailConfirmModal: {
        title:        'Confirme seu e-mail',
        emailField:   { label: 'Digite seu e-mail atual' },
        cancelButton: 'Cancelar',
        confirmButton:'Confirmar'
      },
  
      validation: {
        emailInvalid: 'Formato de e-mail inválido',
        emailRequired:'E-mail obrigatório'
      },
  
      error: {
        noChange:        'Você só consegue avançar trocando e-mail ou senha.',
        fillPassword:    'Preencha todos os campos de senha.',
        passwordMismatch:'As novas senhas não coincidem.',
        passwordLength:  'Nova senha deve ter ao menos 8 caracteres.'
      },
  
      success: {
        changeCreds: 'Credenciais atualizadas com sucesso!'
      }
    },
    inbox: {
        title:           'Caixa de Mensagens ({count} pendências)',
        loginRequired:   'Você precisa estar logado para ver suas mensagens.',
        from:            'de {sender}',
        gold:            '{amount} Ouro 🟨',
        silver:          '{amount} Prata ⚪',
        bronze:          '{amount} Bronze 🟤',
        item:            'Item: {name}'
      },
      wiki: {
        searchPlaceholder: 'Digite para buscar um item…',
        loading:           'Carregando…',
        itemIconAlt:       'Ícone do item {name}',
      
        setItemsTitle: 'Itens do Conjunto',
        setBonusesTitle:'Bônus do Conjunto',
        recipeTitle:    'Receita de Fabricação',
        recipeQty:      'Quantidade: {qty}',
        obtainTitle:    'Como pode ser obtido',
        closeButton:    'Fechar'
      },
      rank: {
        selectGroupLabel: 'Selecione o Englobamento',
        none:             '— nenhum —',
        loading:          'Carregando...',
        position:         'Posição',
        name:             'Nome',
        level:            'Level',
        class:            'Classe',
        rebirth:          'Reencarnação',
        reincarnated:     'Reencarnado',
        notReincarnated:  'Não Reencarnado',
    
        ranks: {
          deaths:        'Rank de Mortes',
          crystalDamage: 'Rank de Dano Cristal',
          heal:          'Rank de Cura',
          playerDamage:  'Rank de Dano em Jogadores',
          wins:          'Rank de Vitórias'
        },
    
        stat: {
          deaths:        'Mortes',
          crystalDamage: 'Dano Cristal',
          heal:          'Cura',
          playerDamage:  'Dano em Jogadores',
          wins:          'Vitórias'
        }
    },
    alchemy: {
        title:           'Olá! Seja bem-vindo, dê a sua sugestão de alquimia',
        alt:             'Imagem de Alquimia',
        roundLabel:      'Rodada {n}:',
        itemPlaceholder: 'ID do Item {n}',
        sendButton:      'Enviar Sugestão ao Discord',
        loginError:      'Você precisa estar logado.',
        successMessage:  'Sugestão enviada com sucesso!',
        sendError:       'Erro ao enviar sugestão.',
        inserirLote: 'Inserir em lote',
        idItem:'Digite o ID do item',

        regras: {
          title:          'Regras!',
          forbiddenIntro: 'Não é permitido:',
          forbiddenItems: 
            'consumíveis da ilha pedras da torre ou do kaos equipamento tarot e drops especiais de invasão, como núcleos de emissário equipamentos (set, arma, anel e capa) de qualquer tipo itens exclusivos da alquimia-s top rw e itens lançados há menos de 2 meses itens NT na última rodada'
          ,
          conclusion: 'Todas as alquimias serão avaliadas; caso descumpra as regras, elas não serão validadas.'
        }
      },
    escala: {
        // Títulos principais
        title: 'Escala de prêmios',
        subtitle: 'Escala do mês de {currentMonthName} – prazo pra fechamento: {timeRemaining}',
        spent: 'Você gastou {spentPoints} pontos',
        chooseYourRescue: 'Escolha seu resgate',

        // Botão “extra eligible”
        btnExtraEligible: 'Você tem itens de rank para resgatar',

        // Tier card (os nomes “Bronze”, “Prata” etc. ficam no data original)
        redeemed: 'Resgatado',
        redeem: 'Resgatar',

        // No card de pacote
        bundlePackage: 'Pacote de itens:',
        noDescription: '[Sem descrição]',

        // Ranking
        topDonorsTitle: 'Nossos 10 melhores doadores do mês',
        columnPlayer: 'Jogador',
        columnSpent: 'Gastos',

        // Prêmios extras
        extraRewardsTitle: 'Prêmios extras para nossos melhores doadores',
        youAre: 'Você está em {rank}º lugar!',
        availablePrizes: 'Prêmios disponíveis:',
        availablePrize: 'Prêmio disponível:',
        clayX: 'Barro ×{quantity}',
        surpriseGMClick: 'Surpresa GM (clique para escolher)',
        instruction: 'Os itens acima são prêmios extras pros nossos melhores doadores. Não deixe de participar.',

        // Botões genéricos
        cancel: 'Cancelar',
        redeemSurprise: 'Resgatar',

        // Títulos de diálogos
        chooseYourSurprise: 'Surpresa GM: Escolha seu item',
        chooseYourExtraSurprise: 'Surpresa GM (Prêmio Extra): Escolha seu item',
        rescueExtraTitle: 'Resgate de Prêmio Extra'
      },
      service: {
    title: 'Solicitar Serviço',
    selectServiceLabel: 'Selecione o serviço',
    options: {
      changeCharacterName: 'Troca de Nome de Personagem',
      recoverItem: 'Recuperar Item',
      changeGuildName: 'Mudança de Nome da Guilda',
      recoverDeletedChar: 'Recuperar Personagem'
    },
    selectCharLabel: 'Selecione o personagem',
    newCharacterNameLabel: 'Novo Nome do Personagem',
    lostItemIdLabel: 'ID do Item Perdido',
    newGuildNameLabel: 'Novo Nome da Guilda',
    deletedCharNameLabel: 'Nome do Personagem Deletado',
    buttonRequest: 'Solicitar',
    errors: {
      notAuthenticated: 'Usuário não autenticado.',
      selectCharAndName: 'Selecione um personagem e informe o novo nome.',
      informItemId: 'Informe o ID do item.',
      informNewGuildName: 'Informe o novo nome da guilda.',
      informDeletedCharName: 'Informe o nome do personagem deletado.'
    },
    success: 'Pedido enviado com sucesso!'
  },
   zephyr: {
    title: 'Adquira Zephyr Points (Compra realizada com moeda brasileira)',
    labelAmountReal: 'Valor em Reais',
    willReceive: 'Você receberá:',
    coins: 'Zephyr Coins',
    buttonBuy: 'Adquirir',
    errorPositive: 'Por favor, insira um valor maior que zero.',
    errorPayment: 'Não foi possível iniciar o pagamento. Tente novamente.',
    docTitle: 'Grand Fantasia Zephyr'
  },
  acquire: {
    title: 'Adquirido com moeda internacional',
    labelValueReal: 'Valor em Reais',
    receive: 'Você receberá:',
    coins: 'Zephyr Coins',
    approxUSD: 'Aproximadamente {usd} USD',
    sendOrderButton: 'Enviar Pedido',
    alertValueGreaterZero: 'Por favor, insira um valor maior que zero.',
    alertLogin: 'Por favor, faça login para continuar.',
    alertSuccess: 'Pedido enviado! Você receberá {coins} Zephyr Coins (≈ {usd} USD).',
    alertError: 'Não foi possível enviar o pedido. Tente novamente.'
  },
  daily:{
    title:'Recompensa diaria',
    subtitle:'Resgate hoje sua recompensa do dia',
    rescue:'Resgatar',
    success: 'Parabens pelo resgate',
    successMessage: 'Item resgatado com sucesso',
    close: 'Fechar'
  },
  roulette: {
    headerTitle: 'Roleta da Sorte Zephyr',
    headerSubPoints: 'Preço da roleta: 500 Zephyr points',
    headerSubBonus: 'Preço da roleta: 1000 Zephyr bonus',
    user: 'Usuário',
    pointsLabel: 'Pontos',
    bonusLabel: 'Bônus',
    title: 'Roleta da Sorte',
    spinButtonAlt: 'Girar',
    insufficientTitle: 'Saldo insuficiente',
    insufficientMessage: 'Você precisa de {cost} Zephyr pontos para girar.',
    close: 'Fechar',
    congratsTitle: 'Parabéns!',
    congratsMessage:
      'Parabéns, você ganhou {quantity}x {name}. Confira na loja do jogo e resgate.'
  }


  }
  